import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Gem, Plane, Shield, Star, Users, Wine, ShoppingBag, Car } from 'lucide-react';

const ServiziDiLusso = () => {
  const { t } = useTranslation();

  const services = [
    { icon: Gem, title: t('serviziLusso.s1t'), desc: t('serviziLusso.s1d') },
    { icon: Shield, title: t('serviziLusso.s2t'), desc: t('serviziLusso.s2d') },
    { icon: Plane, title: t('serviziLusso.s3t'), desc: t('serviziLusso.s3d') },
    { icon: Star, title: t('serviziLusso.s4t'), desc: t('serviziLusso.s4d') },
    { icon: Users, title: t('serviziLusso.s5t'), desc: t('serviziLusso.s5d') },
    { icon: Wine, title: t('serviziLusso.s6t'), desc: t('serviziLusso.s6d') },
    { icon: ShoppingBag, title: t('serviziLusso.s7t'), desc: t('serviziLusso.s7d') },
    { icon: Car, title: t('serviziLusso.s8t'), desc: t('serviziLusso.s8d') },
  ];

  return (
    <div className="servizi-lusso-page">
      <div className="top-bar" />

      <section className="lusso-hero">
        <div className="lusso-hero-content">
          <h1 className="lusso-title">{t('serviziLusso.title')}</h1>
          <p className="lusso-intro">{t('serviziLusso.intro')}</p>
        </div>
      </section>

      <section className="lusso-description">
        <div className="lusso-desc-container">
          <p>{t('serviziLusso.desc')}</p>
          <p className="lusso-signature">{t('serviziLusso.signature')}</p>
        </div>
      </section>

      <section className="lusso-services">
        <h2 className="lusso-services-title">{t('serviziLusso.servicesTitle')}</h2>

        <div className="lusso-services-grid">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <div key={i} className="lusso-service-card">
                <Icon size={40} />
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            );
          })}
        </div>
      </section>

      <section className="lusso-cta">
        <div className="lusso-cta-content">
          <h2>{t('serviziLusso.ctaTitle')}</h2>
          <p>{t('serviziLusso.ctaSub')}</p>
          <Link to="/contatti" className="btn-luxury">{t('serviziLusso.ctaBtn')}</Link>
        </div>
      </section>
    </div>
  );
};

export default ServiziDiLusso;
